module.exports = __webpack_public_path__ + "img/social-media-icon.3a802253.svg";